var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (
    this.params.data.evidencia != undefined &&
      this.params.data.evidencia != '' &&
      this.params.data.evidencia != '[]'
  )?_c('div',[_vm._l((JSON.parse(this.params.data.evidencia)),function(url){return _c('v-btn',{key:url,staticClass:"btnEvidencia",staticStyle:{"min-width":"30px!important"},attrs:{"flat":"","small":"","color":"primary"},on:{"click":function($event){return _vm.showImage(url)}}},[(
        url
          .split('.')
          .pop()
          .toLowerCase() == 'mp4'
      )?_c('v-icon',{staticClass:"importExportBtnIcon",attrs:{"url":url}},[_vm._v("videocam")]):_c('v-icon',{staticClass:"importExportBtnIcon",attrs:{"url":url}},[_vm._v("photo_camera")])],1)}),_c('br')],2):_c('div',[_c('p',[_vm._v("\n    Sin Evidencia\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }